import { Handle, Position } from 'react-flow-renderer';
import s from './nodes.module.scss'

export function ScoreNode(props) {
  return (
    <>
      <Handle type="target" position={Position.Top} />
      <div className={s.scoreNodeContent} >
        <label htmlFor="text">Score Card: {props.data.label}</label>
      </div>
      <Handle type="source" position={Position.Bottom} />
    </>
  );
}